import React, { Component } from 'react';

import { withFixedTitle } from 'src/components';

import Nightingale from 'src/charts/nightingale';

const SquishlessNightingale = withFixedTitle(Nightingale);

/* eslint-disable react/prop-types */

export default class FactorChart extends Component {
  constructor(props) {
    super(props);
    const { objects, selectedFacet, selectedFactor, selectedIndex, eventEmitter } = props;
    const selectedPxScore = objects[selectedIndex].pxScores.find((pxScore) => pxScore.trait.code === selectedFacet);
    this.state = {
      selectedFactor,
      selectedFacet,
      selectedPxScore,
    };
    eventEmitter.subscribe('factorChanged', (code) => {
      this.setState({
        selectedFactor: code,
        selectedFacet: undefined,
      });
    });
    eventEmitter.subscribe('facetChanged', (code) => {
      this.setState({ selectedFacet: code });
    });
  }

  static getDerivedStateFromProps(props, state) {
    const { selectedFactor, selectedFacet, selectedPxScore: currentPxScore } = state;
    if (!selectedFacet) {
      const { objects, selectedIndex, eventEmitter } = props;
      const selectedPxScore = objects[selectedIndex].pxScores.find((pxScore) => pxScore.trait.code === selectedFactor);
      if (currentPxScore !== selectedPxScore) {
        eventEmitter.dispatch('traitChanged', selectedPxScore.trait);
        eventEmitter.dispatch('scoreChanged', selectedPxScore.score);
      }
    }
    return null;
  }

  render() {
    const { objects, oceanFactorLabels, oceanFactorSeries, style, selectedIndex, eventEmitter } = this.props;
    const { selectedFactor } = this.state;
    return (
      <SquishlessNightingale
        title="Big Five Factors"
        labels={oceanFactorLabels}
        series={oceanFactorSeries}
        style={style}
        relativeColors={false}
        selected={selectedFactor}
        onClick={(code) => {
          const selectedPxScore = objects[selectedIndex].pxScores.find((pxScore) => pxScore.trait.code === code);
          eventEmitter.dispatch('factorChanged', code);
          eventEmitter.dispatch('traitChanged', selectedPxScore.trait);
          eventEmitter.dispatch('scoreChanged', selectedPxScore.score);
        }}
        formatter={(showRange) =>
          showRange ? (params) => params.data.rangeName.toUpperCase() : (params) => params.data.trait.toUpperCase()
        }
        showRange
        showRangeControl
      />
    );
  }
}
